import {
  CancelaOrdenDigitalLaboratorioBody,
  CancelaOrdenDigitalLaboratorioBotones,
  CancelaOrdenDigitalLaboratorioContainer,
} from "./localStyle";

const CancelaOrdenDigitalLaboratorio = ({ cancelarTurno , cambiarTurno}) => {
  //#region --------- context ---------------

  //#endregion  ----------- context ---------------

  //#region  ----------- constants ---------------
  const txtOrdenDigitalLaboratorio =
    "Tenga en cuenta que al cancelar el turno no va a poder utilizar nuevamente la orden digital. ¿Desea cancelar?";
  //#endregion --------- constants ---------------

  //#region  ----------- funciones ---------------

  //#endregion --------- funciones ---------------

  //#region  ----------- useEffect ---------------
  //#endregion  ----------- useEffect ---------------
  return (
    <CancelaOrdenDigitalLaboratorioContainer>
      <CancelaOrdenDigitalLaboratorioBody>
        <span className="rb16l">{txtOrdenDigitalLaboratorio}</span>
      </CancelaOrdenDigitalLaboratorioBody>
      <CancelaOrdenDigitalLaboratorioBotones>
        <div
          className="btn bgc-danger c-white rb16l pointer"
          onClick={cancelarTurno}
        >
          Cancelar Turno
        </div>
        <div
          className="btn bgc-danger c-white rb16l pointer"
          onClick={cambiarTurno}
        >
          Cambiar Turno
        </div>
      </CancelaOrdenDigitalLaboratorioBotones>
    </CancelaOrdenDigitalLaboratorioContainer>
  );
};

export default CancelaOrdenDigitalLaboratorio;
